@use "../../styles/variables" as *;
@use "../../styles/mixins" as *;

/* Colors & Variables
------------------------------------ */
$cookie-settings-background-color: $white;
$text-color: $grey;
$button-background-color: $grey;
$button-text-color: $white;
$backdrop-color: $grey-text;

$cookie-headline-font-size: 1rem;
$cookie-description-font-size: .875rem;
$cookie-settings-z-index: 999999;

:host{
 visibility: hidden;
}

:host([active]) {
  visibility: visible;
  display: unset;
  .cookie-settings-container {
    transform: translateX(0);
  }

  .closable-overlay {
    display: block;
  }
}

:host(.hidden) {
  display: none;
}

.closable-overlay {
  display: none;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: $backdrop-color;
  opacity: .5;
  z-index: $cookie-settings-z-index;
}

* {
  font-family: Roboto, sans-serif;
  box-sizing: border-box;
  color: $text-color;

  h1,
  p {
    margin: 0;
    padding: 0;
  }

  p, a {
    font-weight: 300;
  }


}

.cookie-settings-container {

  position: fixed;
  top: 0;
  right: 0;
  transition: all 0.8s ease;
  transform: translateX(100%);
  background: $cookie-settings-background-color;
  display: flex;
  flex-direction: column;
  height: 100%;
  z-index: $cookie-settings-z-index;

  @include tablet {
    max-width: 25.5rem;
  }

  .cookie-settings-header {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1rem 1rem 1.5rem;
    border-bottom: 1px solid $grey-lighter;

    h1 {
      font-size: 1.25rem;
      font-weight: 400;
      line-height: 1.5rem;
    }

    .cookie-settings-header-icon {
      cursor: pointer;

      img {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
  }

  .cookie-settings-body {
    overflow-y: auto;
    flex-grow: 1;
    padding: 1.5rem 1.5rem 0;
    font-size: .875rem;

    @include tablet {
      flex-grow: 0;
      padding: 2rem 1.5rem 0;
    }

    .cookie-settings-introduction {
      p {
        line-height: 1.25rem;

        & + p {
          margin-top: 1.5rem;
        }
      }
    }

    .button-accept-all {
      display: flex;
      justify-content: center;
      margin: 1.5rem 0 0 0;
      padding: 0 1.5rem;

      @include tablet {
        margin: 2rem 0 0 0;
      }
    }

    .cookie-settings-selection {
      margin: 3rem 0;

      @include tablet {
        margin: 4.5rem 0 3rem 0;
      }

      .cookie-container {
        margin: 1.5rem 0;
        line-height: 1.25rem;

        .cookie-checkbox {
          margin-bottom: .25rem;

          input[type="checkbox"] {
            margin-left: 0;
            cursor: pointer;

            &[aria-disabled="true"] {
              cursor: not-allowed;
              opacity: 0.5;
              filter: grayscale(100%)
            }

            &[aria-disabled="true"] + label {
              cursor: not-allowed;
            }
          }

          .cookie-headline {
            font-size: $cookie-headline-font-size;
            font-weight: 700;
            cursor: pointer;
          }
        }

        .cookie-description {
          font-size: $cookie-description-font-size;
        }
      }
    }
  }

  .cookie-settings-footer {
    display: flex;
    justify-content: center;
    padding: 1.125rem 0;
    border-top: 1px solid $grey-lighter;

    @include tablet {
      border-top: none;
    }

    .button-save-selection {
      display: flex;
      justify-content: center;
      width: 100%;
      padding: 0 3rem;
    }
  }

  button {
    border: none;
    background: $button-background-color;
    color: $button-text-color;
    padding: .75rem 1.25rem;
    text-transform: uppercase;
    font-size: .875rem;
    line-height: .875rem;
    letter-spacing: .6px;
    font-weight: 300;
    width: 100%;
    cursor: pointer;
    border-radius: 24px;
  }
}